import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAirpodCase: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="airpod-case, airpods"><path d="M7.25 3C4.90279 3 3 4.90279 3 7.25V9H21V7.25C21 4.90279 19.0972 3 16.75 3H7.25Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M21 10.5H3V16.75C3 19.0972 4.90279 21 7.25 21H16.75C19.0972 21 21 19.0972 21 16.75V10.5ZM12 14.5C12.5523 14.5 13 14.0523 13 13.5C13 12.9477 12.5523 12.5 12 12.5C11.4477 12.5 11 12.9477 11 13.5C11 14.0523 11.4477 14.5 12 14.5Z" fill="currentColor"/></CentralIconBase>;
};

export default IconAirpodCase;
